import DailyLegalReportsWorkspace from "./DailyLegalReportsWorkspace";

export default DailyLegalReportsWorkspace;
